import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { formatNumber } from "@utils/data-display";

/** Convert token packages to card item details for display */
export function convertCreditPackagesToCardItems(packages) {
  if (packages.length === 0) {
    return [];
  }
  const sortedPackages = [...packages].sort((a, b) => a.priceInCents - b.priceInCents);

  /**
   * Index for the 'most popular' badge
   * Middle index is chosen if the list is odd,
   * or the first of the two middle items if even.
   */
  const middleIndex = Math.ceil(sortedPackages.length / 2) - 1;
  const basePackage = sortedPackages[0];
  const basePricePerToken = basePackage.priceInCents / basePackage.tokenAmount;
  return sortedPackages.map((creditPackage, index) => ({
    title: `${formatNumber(creditPackage.tokenAmount)} ${CREDITS_DISPLAY_NAME}`,
    subtitle: formatCreditPackagePrice(creditPackage.priceInCents),
    badgeText: creditPackage.badge,
    value: creditPackage.id,
    additionalBadgeText: index === middleIndex ? "most popular" : undefined,
    titleDescription: getSavingsDescription(creditPackage, basePricePerToken)
  }));
}

/**
 * @returns The savings of a package compared to the price per token of the base package,
 * or undefined if the package doesn't save anything.
 */
function getSavingsDescription(creditPackage, basePricePerToken) {
  const equivalentPrice = creditPackage.tokenAmount * basePricePerToken;
  const savings = equivalentPrice - creditPackage.priceInCents;
  const savingsPercentage = savings / equivalentPrice * 100;
  return savingsPercentage > 0 ? `Save ${savingsPercentage.toFixed(0)}%` : undefined;
}

/**
 * Format a token package price for display in full currency units.
 *
 * @param priceInCents The price of the package in cents.
 * @returns The formatted price in full currency unit (USD).
 */
export function formatCreditPackagePrice(priceInCents) {
  const priceInCurrencyUnit = priceInCents / 100;
  return `$${priceInCurrencyUnit.toLocaleString("en-US")}`;
}